/* eslint-disable arrow-parens */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Centrale } from '@urbasolar_dev/urbaconnect-types'
import React from 'react'
import { useTheme } from 'styled-components'

import { RIRC, RIRP, RP } from '../../../domain/constants/documents.constants'
import { Document, Report } from '../../../domain/documents.types'
import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'
import Checkbox from '../../../ui/components/checkbox'
import { PlantSearchSelected } from '../../components/plantSearchRedirect/plantSearchSelected'
import RadioButton from '../../components/radioButton/radioButton'
import { getIconSort } from '../../components/table/table'
import { FilterProps, Header, Methods, SortConfig } from '../../components/table/table.types'
import {
  BaseButton,
  ModalContainer,
  ModalOverlay,
  RowWrapper,
  Title,
  TriggerButton,
} from './documents.styles'

export interface IDocumentHeader {
  currentConfig: SortConfig
  headers: Header[]
  filters: FilterProps
  wrapperRef: React.MutableRefObject<HTMLDivElement | null>
  selectedPlant: Centrale | null
  selectedItems: Record<string, string | number | null | undefined>[] | Document[] | Report[]
  categorySortVisible: boolean
  categoryFilterVisible: boolean
  setCategorySortVisible: React.Dispatch<React.SetStateAction<boolean>>
  downloadMultipleFiles: (documentsId: { [key: string]: boolean }) => void
  downloadMultipleIsLoading: boolean
  requestSort: (key: string, method: Methods) => void
  handleCategorySelect: (event: { target: { checked: boolean | undefined; value: string } }) => void
}
export const DocumentHeader: React.FC<IDocumentHeader> = ({
  selectedPlant,
  selectedItems,
  categorySortVisible,
  setCategorySortVisible,
  headers,
  currentConfig,
  downloadMultipleFiles,
  downloadMultipleIsLoading,
  requestSort,
  categoryFilterVisible,
  filters,
  handleCategorySelect,
  wrapperRef,
}) => {
  const { isMobile } = useTheme()
  const { t } = useCustomTranslation('common')

  if (isMobile)
    return (
      <RowWrapper>
        <TriggerButton
          onClick={() => setCategorySortVisible(!categorySortVisible)}
          isOpen={categorySortVisible}
        >
          <span style={{ paddingRight: '0.5rem' }}>
            {headers && headers.find((header) => currentConfig.key === header.propertyName)?.value}
          </span>
          <FontAwesomeIcon icon="caret-down" />
        </TriggerButton>
        <div style={{ display: 'flex' }}>
          <BaseButton
            type="button"
            disabled={selectedItems.length < 2}
            onClick={() =>
              downloadMultipleFiles(
                (selectedItems as Document[]).reduce((acc, doc) => {
                  acc[doc.sharepointId] = true
                  return acc
                }, {} as { [key: string]: boolean })
              )
            }
          >
            {!downloadMultipleIsLoading ? (
              <FontAwesomeIcon icon="download" />
            ) : (
              <FontAwesomeIcon icon="spinner" spin />
            )}
          </BaseButton>
          <BaseButton onClick={() => requestSort(currentConfig.key, currentConfig.method)}>
            {getIconSort(currentConfig.key, currentConfig, true)}
          </BaseButton>
        </div>
        {(categoryFilterVisible || categorySortVisible) && (
          <ModalOverlay>
            <ModalContainer ref={wrapperRef}>
              {categoryFilterVisible && (
                <>
                  <div style={{ paddingBottom: '1rem' }}>Filtrer</div>
                  <Checkbox
                    checked={
                      Array.isArray(filters.filterValues) &&
                      filters.filterValues.some((elt) => elt === RP)
                    }
                    name="categorieFilter"
                    label={t('production_reports')}
                    value={RP}
                    onChange={(e: { target: { checked: boolean | undefined; value: string } }) =>
                      handleCategorySelect(e)
                    }
                  />
                  <Checkbox
                    checked={
                      Array.isArray(filters.filterValues) &&
                      filters.filterValues.some((elt) => elt === RIRC)
                    }
                    name="categorieFilter"
                    label={t('corrective_action_reports')}
                    value={RIRC}
                    onChange={(e: { target: { checked: boolean | undefined; value: string } }) =>
                      handleCategorySelect(e)
                    }
                  />
                  <Checkbox
                    checked={
                      Array.isArray(filters.filterValues) &&
                      filters.filterValues.some((elt) => elt === RIRP)
                    }
                    name="categorieFilter"
                    label={t('preventive_action_reports')}
                    value={RIRP}
                    onChange={(e: { target: { checked: boolean | undefined; value: string } }) =>
                      handleCategorySelect(e)
                    }
                  />
                </>
              )}
              {categorySortVisible && (
                <>
                  <div style={{ paddingBottom: '1rem' }}>Trier par :</div>
                  {headers.map((header) => {
                    if (header.propertyName === 'none') return null
                    return (
                      <RadioButton
                        label={header.value}
                        name="sortItemMobile"
                        onChange={() => requestSort(header.propertyName, header.sort)}
                        checked={currentConfig.key === header.propertyName}
                      />
                    )
                  })}
                </>
              )}
            </ModalContainer>
          </ModalOverlay>
        )}
      </RowWrapper>
    )
  return (
    <RowWrapper>
      <Title>
        <PlantSearchSelected selectedPlant={selectedPlant} title={t('documents')} />
      </Title>
    </RowWrapper>
  )
}
